import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { documentService } from '@/services/document.service'
import { SUBMISSIONS_QUERY_KEY } from './useSubmissions'

export const DOCUMENTS_QUERY_KEY = ['documents']

export function useDocuments(submissionId: string | undefined) {
  return useQuery({
    queryKey: [...DOCUMENTS_QUERY_KEY, submissionId],
    queryFn: () => documentService.getDocuments(submissionId!),
    enabled: !!submissionId
  })
}

export function useUploadDocument() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      submissionId,
      file,
      onProgress
    }: {
      submissionId: string
      file: File
      onProgress?: (progress: { loaded: number; total: number; percentage: number }) => void
    }) => {
      return documentService.uploadDocument(submissionId, file, onProgress)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: DOCUMENTS_QUERY_KEY })
      queryClient.invalidateQueries({ queryKey: SUBMISSIONS_QUERY_KEY })
    }
  })
}

export function useDeleteDocument() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (documentId: string) => documentService.deleteDocument(documentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: DOCUMENTS_QUERY_KEY })
      queryClient.invalidateQueries({ queryKey: SUBMISSIONS_QUERY_KEY })
    }
  })
}

export function useDocumentUrl(storagePath: string | undefined) {
  return useQuery({
    queryKey: [...DOCUMENTS_QUERY_KEY, 'url', storagePath],
    queryFn: () => documentService.getSignedUrl(storagePath!),
    enabled: !!storagePath,
    staleTime: 1000 * 60 * 30 // 30 minutes (half of URL expiry)
  })
}
